'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _justify = require('./justify.cssm');

var _justify2 = _interopRequireDefault(_justify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A simple layout component that uses `display: flex` with
 * `justify-content: space-between` to arrange its children. The first child
 * will stick to the left side, and the last child will stick to the right side.
 */
var Justify = function (_Component) {
  _inherits(Justify, _Component);

  function Justify() {
    _classCallCheck(this, Justify);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Justify).apply(this, arguments));
  }

  _createClass(Justify, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var className = _props.className;
      var baseline = _props.baseline;


      var classes = (0, _classnames2.default)(_justify2.default.wrapper, baseline && _justify2.default.baseline, 'ls-justify', className);

      return _react2.default.createElement(
        'div',
        { className: classes },
        children
      );
    }
  }]);

  return Justify;
}(_react.Component);

Justify.propTypes = {
  children: _react.PropTypes.any,
  className: _react.PropTypes.string,
  baseline: _react.PropTypes.bool
};
exports.default = Justify;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2p1c3RpZnkvanVzdGlmeS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBS0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7O0FBRUE7Ozs7O0lBS3FCLE87Ozs7Ozs7Ozs7OzZCQU9WO0FBQUEsbUJBQ21DLEtBQUssS0FEeEM7QUFBQSxVQUNDLFFBREQsVUFDQyxRQUREO0FBQUEsVUFDVyxTQURYLFVBQ1csU0FEWDtBQUFBLFVBQ3NCLFFBRHRCLFVBQ3NCLFFBRHRCOzs7QUFHUCxVQUFNLFVBQVUsMEJBQ2Qsa0JBQU8sT0FETyxFQUVkLFlBQVksa0JBQU8sUUFGTCxFQUdkLFlBSGMsRUFJZCxTQUpjLENBQWhCOztBQU9BLGFBQ0U7QUFBQTtBQUFBLFVBQUssV0FBVyxPQUFoQjtBQUEwQjtBQUExQixPQURGO0FBR0Q7Ozs7OztBQXBCa0IsTyxDQUNaLFMsR0FBWTtBQUNqQixZQUFVLGlCQUFVLEdBREg7QUFFakIsYUFBVyxpQkFBVSxNQUZKO0FBR2pCLFlBQVUsaUJBQVU7QUFISCxDO2tCQURBLE87QUFxQnBCIiwiZmlsZSI6Imp1c3RpZnkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHtcbiAgQ29tcG9uZW50LFxuICBQcm9wVHlwZXMsXG59IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IGNsYXNzTmFtZXMgZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgc3R5bGVzIGZyb20gJy4vanVzdGlmeS5jc3NtJztcblxuLyoqXG4gKiBBIHNpbXBsZSBsYXlvdXQgY29tcG9uZW50IHRoYXQgdXNlcyBgZGlzcGxheTogZmxleGAgd2l0aFxuICogYGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbmAgdG8gYXJyYW5nZSBpdHMgY2hpbGRyZW4uIFRoZSBmaXJzdCBjaGlsZFxuICogd2lsbCBzdGljayB0byB0aGUgbGVmdCBzaWRlLCBhbmQgdGhlIGxhc3QgY2hpbGQgd2lsbCBzdGljayB0byB0aGUgcmlnaHQgc2lkZS5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgY2xhc3MgSnVzdGlmeSBleHRlbmRzIENvbXBvbmVudCB7XG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgY2hpbGRyZW46IFByb3BUeXBlcy5hbnksXG4gICAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIGJhc2VsaW5lOiBQcm9wVHlwZXMuYm9vbCxcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBiYXNlbGluZSB9ID0gdGhpcy5wcm9wcztcblxuICAgIGNvbnN0IGNsYXNzZXMgPSBjbGFzc05hbWVzKFxuICAgICAgc3R5bGVzLndyYXBwZXIsXG4gICAgICBiYXNlbGluZSAmJiBzdHlsZXMuYmFzZWxpbmUsXG4gICAgICAnbHMtanVzdGlmeScsXG4gICAgICBjbGFzc05hbWUsXG4gICAgKTtcblxuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT17Y2xhc3Nlc30+e2NoaWxkcmVufTwvZGl2PlxuICAgICk7XG4gIH1cbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/justify/justify.js
// module id = 148
// module chunks = 0